var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "icons-live",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Live Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.172 7.75797C8.781 7.36697 8.149 7.36697 7.758 7.75797C6.624 8.88997 6 10.397 6 12C6 13.603 6.624 15.109 7.758 16.243C7.953 16.438 8.209 16.536 8.465 16.536C8.721 16.536 8.977 16.438 9.172 16.243C9.563 15.852 9.563 15.22 9.172 14.829C8.416 14.073 8 13.068 8 12C8 10.932 8.416 9.92797 9.172 9.17197C9.562 8.78097 9.562 8.14797 9.172 7.75797Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2419 7.75797C15.8509 7.36697 15.2189 7.36697 14.8279 7.75797C14.4369 8.14897 14.4369 8.78097 14.8279 9.17197C15.5839 9.92697 15.9999 10.931 15.9999 12C15.9999 13.069 15.5839 14.073 14.8279 14.829C14.4369 15.22 14.4369 15.852 14.8279 16.243C15.0229 16.438 15.2789 16.536 15.5349 16.536C15.7909 16.536 16.0469 16.438 16.2419 16.243C17.3759 15.109 17.9999 13.602 17.9999 12C17.9999 10.398 17.3759 8.88997 16.2419 7.75797Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34313 6.34299C6.73413 5.95199 6.73413 5.31999 6.34313 4.92899C5.95213 4.53799 5.32013 4.53799 4.92913 4.92899C1.03013 8.82699 1.03013 15.172 4.92913 19.071C5.12413 19.266 5.38013 19.364 5.63613 19.364C5.89213 19.364 6.14813 19.266 6.34313 19.071C6.73413 18.68 6.73413 18.048 6.34313 17.657C3.22413 14.538 3.22413 9.46299 6.34313 6.34299Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.071 4.92899C18.68 4.53799 18.048 4.53799 17.657 4.92899C17.266 5.31999 17.266 5.95199 17.657 6.34299C20.776 9.46199 20.776 14.537 17.657 17.656C17.266 18.047 17.266 18.679 17.657 19.07C17.852 19.265 18.108 19.363 18.364 19.363C18.62 19.363 18.876 19.265 19.071 19.07C22.971 15.173 22.971 8.82799 19.071 4.92899Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.6c94adc92b082a95cf600c77b7c5c2e4.svg";
export { ForwardRef as ReactComponent };